(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gg-matvalet-styles"] && !Shopify.designMode) return;
  try {
    {
  let scheduled = false;
  const updateUppercaseTracking = () => {
    scheduled = false;
    document.querySelectorAll('.mv').forEach(root => {
      root.querySelectorAll('*').forEach(element => {
        if (element.closest('script, style, svg, noscript, .ggicon, .jdgm-widget')) return;
        const text = Array.from(element.childNodes)
          .filter(node => node.nodeType === Node.TEXT_NODE)
          .map(node => node.textContent).join('').trim();
        const hasLetters = text.toLocaleUpperCase('sv') !== text.toLocaleLowerCase('sv');
        const uppercase = hasLetters && (
          getComputedStyle(element).textTransform === 'uppercase' ||
          text === text.toLocaleUpperCase('sv')
        );
        element.toggleAttribute('data-mv-uppercase', uppercase);
      });
    });
  };
  const scheduleUppercaseTracking = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(updateUppercaseTracking);
  };
  const startUppercaseTracking = () => {
    if (!document.querySelector('.mv')) return;
    updateUppercaseTracking();
    const observer = new MutationObserver(scheduleUppercaseTracking);
    observer.observe(document.querySelector('main') || document.body, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });
    document.addEventListener('shopify:section:load', scheduleUppercaseTracking);
    window.addEventListener('resize', scheduleUppercaseTracking, { passive: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startUppercaseTracking, { once: true });
  } else {
    startUppercaseTracking();
  }
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wld-brandon-line-height"] && !Shopify.designMode) return;
  try {
    (() => {
  const pending = new Set();
  let frame = 0;
  const inspect = root => {
    const nodes = [root, ...root.querySelectorAll('*')];
    for (const el of nodes) {
      if (!(el instanceof HTMLElement) || /^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE)$/.test(el.tagName)) continue;
      const hasText = [...el.childNodes].some(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim()) || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName);
      const family = hasText ? getComputedStyle(el).fontFamily.split(',')[0].replace(/["']/g, '').trim().toLowerCase() : '';
      const isBrandon = family === 'brandon text' || family === 'brandon-text' || family === 'brandon_text';
      if (el.hasAttribute('data-wld-brandon-line') !== isBrandon) el.toggleAttribute('data-wld-brandon-line', isBrandon);
    }
  };
  const queue = root => {
    if (!(root instanceof HTMLElement)) return;
    pending.add(root);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      const roots = [...pending];
      pending.clear();
      for (const node of roots) if (node.isConnected && !roots.some(other => other !== node && other.contains(node))) inspect(node);
    });
  };
  const start = () => {
    inspect(document.body);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') queue(record.target);
        else if (record.type === 'characterData') queue(record.target.parentElement);
        else { for (const node of record.addedNodes) queue(node.nodeType === Node.TEXT_NODE ? node.parentElement : node); }
      }
    }).observe(document.body, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','style']});
    document.addEventListener('shopify:section:load', event => queue(event.target));
    window.addEventListener('resize', () => queue(document.body), {passive:true});
    document.fonts.ready.then(() => queue(document.body));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
